/**
 * notifications.js
 */

import React from 'react';
import { Badge, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BarButton from '../bar-button';
import Icon from 'components/icon';
import NotificationsContext from 'contexts/notifications/notifications.context';

const useStyles = makeStyles(theme => ({
  badge: {
    fontSize: theme.typography.sizes[1],
    fontWeight: 600,
    backgroundColor: theme.palette.secondary.colors[5],
    color: theme.palette.primary.colors[0],
    padding: '0px',
    scale: 0.85,
  },
}));

export default function NotificationsButton(props) {
  const classes = useStyles();
  const notificationIcon = <Icon type='notification' />  
  const { unreadCount, setOpen } = React.useContext(NotificationsContext);

  const openDrawer = (event) => {
    setOpen(true);
  }

  return <>
    <Tooltip
      arrow
      placement='bottom'
      title='View Notifications'
    >
      <span style={{ display: 'inline-block' }}>
        <BarButton
          aria-label="notification list"
          onClick={openDrawer}
          data-testid='notifications-button'
        >
          {unreadCount > 0 &&
          <Badge 
            badgeContent={unreadCount} 
            color="secondary" 
            overlap="circular"
            classes={{badge: classes.badge}}
          >
            {notificationIcon}
          </Badge>}

          {unreadCount === 0 && notificationIcon}
        </BarButton>
      </span>
    </Tooltip>
  </>;
}